import jquery from 'jquery';
/**
 * @memberof module:ajaxAPI/articlce
 * @alias get
 *
 * @description Получение отзывов к статье
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.shop.product.getReviews()
 *  .done(function (onDone) { console.log('onDone:', onDone) })
 *  .fail(function (onFail) { console.log('onFail:', onFail) });
 */

export default function(articleId) {
  var link = '/front_api/articles/' + articleId + '/comments.json';

  return jquery.getJSON(link);
}
